import { render, staticRenderFns } from "./SelfEvaluate.vue?vue&type=template&id=5fbd87f2&scoped=true"
import script from "./SelfEvaluate.vue?vue&type=script&lang=js"
export * from "./SelfEvaluate.vue?vue&type=script&lang=js"
import style0 from "./SelfEvaluate.vue?vue&type=style&index=0&id=5fbd87f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd87f2",
  null
  
)

export default component.exports